import useTableRequest from "../../hooks/useTableRequest";
import { useEffect, useState } from "react";
import Table from "../../components/common/table/Table";
import Title from "../../components/common/title/Title";
import { userListColumns } from "../../constant/tables-columns/tablesColums";
import Pagination from "../../components/common/pagination/Pagination";
import { useNavigate } from "react-router";
import UserFilter from "./UserFilter";
import { useSelector } from "react-redux";
import { utilsState } from "../../sotre/redux/features/utilsSlice";

export default function UserList() {
  const tableRequest = useTableRequest({ initialLoading: true });
  const [userData, setUserData] = useState([]);
  const [pagination, setPagination] = useState(null);

  const { utils } = useSelector(utilsState);

  const getUser = async (params) => {
    const path = "admin/users";
    return tableRequest.load({ path, params: { ...params } }, (response) => {
      setUserData(response?.data?.result.data);
      setPagination(response?.data?.result);
    });
  };

  useEffect(() => {
    getUser({});
  }, []);

  const [filter, setFilter] = useState();

  const filterDataHandler = (newParams) => {
    setFilter({ ...filter, ...newParams });
    const allFilter = {
      ...filter,
      ...newParams,
    };
    console.log("filter", allFilter);
    getUser(allFilter);
  };

  const data = [];

  userData?.map((item) =>
    data.push({
      ...item,
      faRole: utils?.ROLES?.[item?.role]?.name || "",
      key: item._id,
      id: item._id,
      createdAt: "1403",
    })
  );

  console.log(data);

  const navigate = useNavigate();

  const editUser = (singleUser) => {
    navigate("/edit-user", { state: singleUser });
  };

  return (
    <div className="bg-white dark:bg-gray-900 rounded-3xl p-6">
      <Title title={"لیست کاربران"} />

      <UserFilter filterDataHandler={filterDataHandler} />
      <Pagination
        pagination={pagination}
        filterDataHandler={filterDataHandler}
      />
      <Table loading={tableRequest.loading} error={tableRequest.error} idle={tableRequest.status === "idle"} onRetry={tableRequest.retry} columns={userListColumns} rows={data} onEdit={editUser} />

      <Pagination
        pagination={pagination}
        filterDataHandler={filterDataHandler}
      />
    </div>
  );
}
